import PreviewButton from "../PreviewButton";
import TaskInformation from "../TaskInformation";
import ContractData from "./ContractData";
import React, {useEffect, useRef, useState} from "react";
import Paper from "@material-ui/core/Paper";
import {useDispatch, useSelector} from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {completeTask, getTask} from "../../../store/action/taskAction";
import * as Actions from "../../../store/action/claimManagement";
import ValidationButton from "../ValidationButton";
import {useNavigate, useParams} from "react-router-dom";
import ErrorsAlert from "../../../utils/errorsAlert";
import MaskedDecimalInput from "../../../utils/MaskedDecimalInput";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        position: 'relative',
    },
    paper: {
        display: 'grid',
        gridTemplateRows: '0.5fr 0.5fr',
        gap: '20px',
        padding: '20px',
        borderRadius: '11px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
    },
    previewBtn: {
        position: 'absolute',
        //background: 'rgb(243, 246, 249)',
        right: '20px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    },
    firstPart: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '35px',
    },
    secondPart: {
        display: 'block',
    },
    thirdPart: {
        display: 'grid',
        gridTemplateColumns: '60% 40%',
        marginTop: '20px',
        gap: '5px', 
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
    },
    table2: {
        width: '80%',
    },
    tableHeader: {
        fontFamily: 'Inter',
        fontSize: '16px',
        fontWeight: 700,
        textAlign: 'left',
        color: 'rgba(70, 78, 95, 1)',
        paddingBottom: '10px',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
    },
    tableTh: {
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontWeight: 600,
        color: 'rgba(181, 181, 195, 1)',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
        textAlign: 'left',
        paddingLeft: '5px',
        paddingBottom: '12px',
        paddingTop: '12px',
    },
    tableRow: {
        padding: '0',
    },
    tableContent: {
        paddingLeft: '5px',
        textAlign: 'left',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
        paddingBottom: '9px',
        paddingTop: '12px',
    },
    selectInput: {
        width: '70%',
        //padding: '10px',
        fontSize: '14px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        //marginTop: '5px',
        //marginBottom: '15px',
    },
    card: {
        width: '100%',
        height: '80%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginLeft: 0,
        },
        minHeight: '200px',
    },
    cardItem: {
        display: 'flex',
        justifyContent: 'space-between',
        color: 'rgba(128, 128, 143, 1)',
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '13px',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
        paddingBottom: '3px',
        paddingTop: '3px',
        alignItems: 'center'
    },
    optionText: {
        padding: "5px",
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12,
    },
    inputContainer: {
        border: 'rgba(243, 246, 249, 1)',
        background: 'rgba(243, 246, 249, 1)',
        width: "70%",
        height: '36px',
        borderRadius: 4,
        marginBottom: "20px",
    },
    inputLabel: {
        color: 'rgba(70, 78, 95, 1)',
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12,
    },
    inputText: {
        border: '1px solid rgba(231, 231, 231, 1)',
        background: 'rgba(255, 255, 255, 1)',
        width: '176px',
        height: '36px',
        borderRadius: '4px 0px 0px 0px',
        textAlign: 'right',
        opacity: '1',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
}));

const ClientPartPaymentPartner = () => {
    const { taskId } = useParams();

    const navigate = useNavigate();
    const classes = useStyles();
    const dispatch = useDispatch(); 
    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
     

    const currentUser = localStorage.getItem('username');
    const taskReducer = useSelector((state) => state.taskReducer.taskList.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer)
    const [clientDecision, setClientDecision] = useState("");
    const [camundaVariables, setCamundaVariables] = useState(task?.variables)
    const [infoSinistre, setInfoSinistre] = useState(task?.businessKey)
    const [subMotifOptions, setSubMotifOptions] = useState([]);
    const [subMotif, setSubMotif] = useState("");
    const [totalAmountWOTax, setTotalAmountWOTax] = useState(0);
    const [totalAmountWTax, setTotalAmountWTax] = useState(0);
    const [tva, setTva] = useState(0);
    const [dataClientPart, setDataClientPart] = useState({
        franchise: "0.000",
        rp: "0.000",
        ceilingExceedance: "0.000",
        customerPayment: "0.000"
    });

    const [capital, setCapital] = useState();
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errors, setErrors] = useState([]);

    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };

    const getFinancialDocuments = async () => {
        try {
            const claimfinancialDocument = await dispatch(Actions.getFinancialDocuments(task?.businessKey));
            console.log("claimfinancialDocument", claimfinancialDocument)
            const financialDocument = claimfinancialDocument.filter((financialDocument) => financialDocument.type === "QUOTATION")
            
            if (financialDocument.length > 0) {
                const totalAmountWOTax = financialDocument[financialDocument.length - 1].totalAmountWOTax;
                const totalAmountWTax = financialDocument[financialDocument.length - 1].totalAmountWTax;
                const vatAmount = totalAmountWTax - totalAmountWOTax; 
                
                setTotalAmountWOTax(totalAmountWOTax);
                setTotalAmountWTax(totalAmountWTax);
                setTva(vatAmount); //1 DT droit du timbre
                setDataClientPart(prev => ({
                    ...prev,
                    customerPayment: (vatAmount).toFixed(3)
                  }));
                  
            } else {
              setTotalAmountWOTax("-");
              setTotalAmountWTax("-");
              setTva("-");
            }
          }catch (error) {
            console.error("Error fetching claim data:", error);
        }
    };

   
    const fetchTask = async () => {
        try {
            const response = await getTask(taskId, currentUser);
            setTask(response)
            setInfoSinistre(response?.businessKey)
            setCamundaVariables(response?.variables)
        } catch (error) {
            console.error(`Error fetching task details: ${error.message}`);
        }
    };
    useEffect(() => {
       
        fetchTask(); 
    }, [dispatch, taskId, currentUser]);


   
    
    useEffect(() => {
        if (task?.assignee === currentUser) {
            setIsTaskClaimed(false);
        } else {
            setIsTaskClaimed(true);
        }

        getFinancialDocuments();
        
    }, [task]);
    

    useEffect(() => {
        if (clientDecision === "REFUSAL") {
            // Automatically set the motif and fetch sub-motifs
            const motifId = "client-ne-veut-pas-payer"; // will be replaced with actual ID when available
            setSubMotifOptions(["Sub-motif 1", "Sub-motif 2", "Sub-motif 3"]); // will be replaced with actual sub-motifs
        } else {
            setSubMotifOptions([]);
            setSubMotif("");
        }
    }, [clientDecision]);

    useEffect(() => {
        setDataClientPart(prev => {
            const franchise = parseFloat(prev.franchise) || 0;
            const ceilingExceedance = parseFloat(prev.ceilingExceedance) || 0;
            const tvaValue = parseFloat(tva) || 0;

            return {
                ...prev,
                customerPayment: (franchise + ceilingExceedance + tvaValue).toFixed(3)
            };
        });
    }, [tva]);

    const updatedataClientPart = (event) => {
        const { name, value } = event.target;

        // Allow empty string or a valid number with up to 3 decimal digits
        const regex = /^\d*(\.|,)?\d{0,3}$/;
        const normalizedValue = value.replace(',', '.');

        if (regex.test(normalizedValue) || normalizedValue === '') {
            setDataClientPart(prevState => {
                const updatedState = {
                    ...prevState,
                    [name]: normalizedValue
                };

                if (name === "franchise" || name === "ceilingExceedance") {
                    const franchise = parseFloat(updatedState.franchise) || 0;
                    const ceilingExceedance = parseFloat(updatedState.ceilingExceedance) || 0;
                    const tvaValue = parseFloat(tva) || 0;

                    updatedState.customerPayment = (franchise + ceilingExceedance + tvaValue).toFixed(3);
                }

                return updatedState;
            });
        }
    };

    const handleValidation = async () => {
        const validationErrors = [];

        if (!clientDecision) {
            validationErrors.push("La décision du client est requise");
        }

        if (clientDecision === "REFUSAL" && !subMotif) {
            validationErrors.push("Un sous-motif est requis pour un refus");
        }

        const numericFields = ['franchise', 'rp', 'ceilingExceedance', 'customerPayment'];
        numericFields.forEach(field => {
            if (isNaN(dataClientPart[field])) {
                validationErrors.push(`Le champ ${field} doit être un nombre valide`);
            } else if (dataClientPart[field] < 0) {
                validationErrors.push(`Le champ ${field} ne peut pas être négatif`);
            }
        });

       

        if (totalAmountWOTax === "-" || totalAmountWTax === "-") {
            validationErrors.push("Les documents financiers n'ont pas pu être chargés");
        }

        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }

        try {
            const serviceProposalObject = {
                clientDecision ,
                customerPayment: dataClientPart.customerPayment,
                franchise: dataClientPart.franchise,
                tva :tva ,
                rp: dataClientPart.rp,
                ceilingExceedance: dataClientPart.ceilingExceedance
            };

            const serviceProposalId = task?.variables?._proposedServiceId?.value;
            await Actions.updateServiceProposal(serviceProposalId, serviceProposalObject);
            setCamundaVariables( camundaVariables.customerPayment = {
                "value": dataClientPart.customerPayment,
                "type": "Double"
            });
            setCamundaVariables(camundaVariables.serviceProposalClientDecision = {
                "value": clientDecision,
                "type": "String"
            });
            if (clientDecision === "REFUSAL") {
                setCamundaVariables(camundaVariables.serviceProposalRefusalMotif = {
                    "value": subMotif,
                    "type": "String"
                });
            }

            await dispatch(completeTask(taskId, currentUser, camundaVariables));
            navigate('/todo-list', { reload: true });
        } catch (error) {
            console.error("Error during validation process:", error);
            setErrors(["Une erreur s'est produite lors de la validation"]);
            setOpenErrorDialog(true);
        }
    };


    return (
        <div className={classes.root}>
            
                 
                <div style={{display: 'flex'}}>    
<div className={classes.mainContent}>
                <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed} />
                <Paper className={classes.paper}>
 
                    <div className={classes.secondPart}>
                    {task &&
                            <ContractData  
                                policyNumber={task?.variables?.policyNumber?.value} 
                                occurrenceDate ={task?.variables?.occurrenceDate?.value} 
                                affectedWaranties ={task?.variables?.affectedWaranties?.value}
                            />
                        } 
                    </div>
                    <div className={classes.thirdPart}>
                    <div style={{display:"block"}} > 
                            
                            <table className={classes.table2}>
                                    <thead>
                                    <tr className={classes.tableHeader}>
                                        <th colSpan="3">Données Devis</th>
                                    </tr>
                                    <tr>
                                        <th className={classes.tableTh}>Total Sans Tax</th>
                                        <th className={classes.tableTh}>TVA</th>
                                        <th className={classes.tableTh}>TTC</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr className={classes.tableRow}>
                                        <td className={classes.tableContent}>{totalAmountWOTax}</td>
                                        <td className={classes.tableContent}>{Number(tva).toFixed(3)}</td>    
                                        <td className={classes.tableContent}>{totalAmountWTax}</td>
                                    </tr>
                                    </tbody>
                            </table>
                            
                            <div>
                                <br/>
                                <label className={classes.inputLabel}>Décision du client</label><br/>
                                <select className={classes.inputContainer} name="clientDecision"
                                        value={clientDecision} onChange={(e) => setClientDecision(e.target.value)}
                                        disabled={isTaskClaimed}>
                                    <option className={classes.optionText} value=""></option>
                                    <option className={classes.optionText} value="ACCEPTANCE">Accepté</option>
                                    <option className={classes.optionText} value="REFUSAL">Refusé</option>
                                </select>

                                {clientDecision === "REFUSAL" ? (
                                <div>
                                    
                                    <label className={classes.inputLabel}>Sub-Motif</label><br/>
                                    <select className={classes.inputContainer} name="subMotif"
                                            value={subMotif} onChange={(e) => setSubMotif(e.target.value)}
                                            disabled={isTaskClaimed}>
                                        <option className={classes.optionText} value=""></option>
                                        {subMotifOptions.map((option, index) => (
                                            <option key={index} className={classes.optionText} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>
                            ):<div style={{marginBottom : '10%'}}></div>}
                            </div>
                        </div>
                            <div className={classes.card}>
                                <div className={classes.cardItem}><span>Franchise</span>
                                    <MaskedDecimalInput
                                        disabled={isTaskClaimed}
                                        className={classes.inputText}
                                        name="franchise"
                                        value={dataClientPart.franchise}
                                        onChange={(val) => {
                                            setDataClientPart(prev => {
                                                const franchise = parseFloat(val) || 0;
                                                const ceilingExceedance = parseFloat(prev.ceilingExceedance) || 0;
                                                const tvaValue = parseFloat(tva) || 0;

                                                return {
                                                    ...prev,
                                                    franchise: val,
                                                    customerPayment: (franchise + ceilingExceedance + tvaValue).toFixed(3)
                                                };
                                            });
                                        }}
                                    />
                                </div>
                                {/* <div className={classes.cardItem}><span>RP</span>
                                    <input name="rp" value={dataClientPart.rp} onChange={updatedataClientPart} className={classes.inputText} disabled={isTaskClaimed}/>
                                </div> */}
                                <div className={classes.cardItem}><span>TVA</span>
                                <span>{tva ? Number(tva).toFixed(3).replace('.', ',') : '-'}</span>
                                </div>
                                <div className={classes.cardItem}><span>Dépassement plafond</span>
                                    <MaskedDecimalInput
                                        disabled={isTaskClaimed}
                                        className={classes.inputText}
                                        name="ceilingExceedance"
                                        value={dataClientPart.ceilingExceedance}
                                        onChange={(val) => {
                                            setDataClientPart(prev => {
                                                const franchise = parseFloat(prev.franchise) || 0;
                                                const ceilingExceedance = parseFloat(val) || 0;
                                                const tvaValue = parseFloat(tva) || 0;

                                                return {
                                                    ...prev,
                                                    ceilingExceedance: val,
                                                    customerPayment: (franchise + ceilingExceedance + tvaValue).toFixed(3)
                                                };
                                            });
                                        }}
                                    />
                                </div>
                                <div className={classes.cardItem} >
                                    <span style={{color: "rgba(60, 101, 86, 1)" , fontFamily: 'Poppins',fontSize: '13px',fontWeight: 700,}}>Total</span>
                                    <MaskedDecimalInput
                                        disabled={isTaskClaimed}
                                        className={classes.inputText}
                                        name="customerPayment"
                                        value={dataClientPart.customerPayment}
                                        onChange={(val) => {
                                            updatedataClientPart({
                                                target: {
                                                    name: "customerPayment",
                                                    value: val
                                                }
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                    </div>
                   
                            
                </Paper>
            </div>
            <PreviewButton claimData={infoSinistre}  />
</div>

            <ValidationButton taskId={taskId} handleValidation={() =>isTaskClaimed? null : handleValidation()} />
            <ErrorsAlert
                open={openErrorDialog}
                errors={errors}
                handleClose={handleClose}
            />
        </div>
    )
}

export default ClientPartPaymentPartner;
